export default "__VITE_ASSET__C8aP5Xqv__"